import axios from "axios";

export const api = axios.create({
  //withCredentials: true,
  baseURL: "https://app.bluedesert-73985da3.westeurope.azurecontainerapps.io",
})

